import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUploadService } from '../../services/file-upload/file-upload.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-evidences-modal',
  templateUrl: './evidences-modal.component.html',
  styleUrls: ['./evidences-modal.component.sass'],
})
export class EvidencesModalComponent implements OnInit {
  evidenceList: string[] = [];
  loading = true;
  loadError = false;

  constructor(
    public dialogRef: MatDialogRef<EvidencesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fileUploadService: FileUploadService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.data?.idTrade) {
      this.loadGallery();
    } else {
      this.loading = false;
      this.loadError = true;
    }
  }

  loadGallery() {
    this.loading = true;
    this.loadError = false;
    const urlSource = 'COLLECT_TVF.getTradeGallery';

    this.fileUploadService
      .getGalleryByTradeId(this.data.idTrade, urlSource)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.evidenceList = Array.from(new Set<string>([
            ...(res?.stiImages || []),
            ...(res?.images || []),
          ])).filter(Boolean);
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.loadError = true;
          console.error('Erro ao carregar galeria', err);
        },
      });
  }

  zoomImage(template: TemplateRef<unknown>, image: string): void {
    this.dialog.open(template, {
      data: image,
      width: '90vw',
      maxWidth: '1100px',
      height: '90vh',
      panelClass: 'no-padding-dialog',
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
